var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-input"},[_c('div',{staticClass:"detail-input__label"},[_c('label',{class:_vm.required ? 'required' : '',attrs:{"for":"checkingType"}},[_vm._v(" "+_vm._s(_vm.propsLabel)+" ")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }